export enum EBrand {
  NoBrand = "nobrand",
  PayPal = "paypal",
  ApplePay = "applepay",
  default = "default",
}
